import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Text, Button, Image, Grid
} from 'components/ui';
import Markdown from 'components/Markdown/Markdown';
import Empty from 'constants/empty';
import SDULandingPageModal from 'components/GlobalModals/SDULandingPageModal';

function SDUBanner(props) {
    const {
        localization,
        sduMiddleText,
        ctaButtonText,
        showSDULandingPageModal,
        isSDULandingPageModalOpen,
        isUserSDUTrialEligible,
        isSDUAddedToBasket
    } = props;
    const closeSDULandingPageModal = () => showSDULandingPageModal(false);

    const ctaButtonProps = {
        variant: 'secondary',
        marginTop: 2,
        minWidth: 115,
        onClick: showSDULandingPageModal,
        children: ctaButtonText
    };

    return (
        <Box
            backgroundColor={['nearWhite', null, 'white']}
            borderColor={[null, null, 'lightGray']}
            borderRadius={3}
            borderWidth={[0, null, 1]}
            marginTop={4}
            padding={3}
        >
            <Grid
                columns={['auto 1fr', null, 1]}
                gap={5}
            >
                <Image
                    display={['block', null, 'none']}
                    disableLazyLoad={true}
                    src={'/img/ufe/icons/same-day-unlimited.svg'}
                    width={32}
                    height={49}
                />
                <Box lineHeight='tight'>
                    <Text
                        display={['none', null, 'block']}
                        color='red'
                        fontWeight='bold'
                    >
                        {localization.getFreeSameDayDelivery}
                    </Text>
                    <Markdown
                        display={['block', null, 'none']}
                        fontWeight='bold'
                        css={styles.bannerMarkdownTitle}
                        content={localization.getFreeSameDayDeliverySMUI}
                    />
                    <Markdown
                        content={sduMiddleText}
                        fontSize={['sm', null, 'base']}
                    />
                    <Box display={['none', null, 'block']}>
                        <Button
                            size='xs'
                            {...ctaButtonProps}
                        />
                    </Box>
                    <Box display={['block', null, 'none']}>
                        <Button
                            size='sm'
                            {...ctaButtonProps}
                        />
                    </Box>
                </Box>
            </Grid>
            <SDULandingPageModal
                skipConfirmationModal
                isOpen={isSDULandingPageModalOpen}
                onDismiss={closeSDULandingPageModal}
                isSDUAddedToBasket={isSDUAddedToBasket}
                isUserSDUTrialEligible={isUserSDUTrialEligible}
            />
        </Box>
    );
}

const styles = {
    bannerMarkdownTitle: {
        '& > :first-child': {
            display: 'inline'
        }
    }
};

SDUBanner.propTypes = {
    localization: PropTypes.object,
    ctaButtonText: PropTypes.string,
    sduMiddleText: PropTypes.string,
    isSDULandingPageModalOpen: PropTypes.bool,
    showSDULandingPageModal: PropTypes.func
};

SDUBanner.defaultProps = {
    localization: Empty.Object,
    ctaButtonText: '',
    sduMiddleText: '',
    isSDULandingPageModalOpen: false,
    showSDULandingPageModal: Empty.Function
};

export default wrapFunctionalComponent(SDUBanner, 'SDUBanner');
